import type { ModerationSettings } from '@tribeplatform/gql-client/types'
import type { ModerationSettingsFields } from '@tribeplatform/gql-client/types/generated'

import { useQuery, UseQueryOptions } from '../../lib/react-query/useQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getModerationSettingsKey } from '../../utils/keys/moderation.key.js'

export const useModerationSettings = (options?: {
  fields?: ModerationSettingsFields
  useQueryOptions?: UseQueryOptions<ModerationSettings>
}) => {
  const { useQueryOptions, fields } = options || {}
  const { client } = useTribeClient()
  const moderationSettingsKey = getModerationSettingsKey()

  return useQuery<ModerationSettings>(
    moderationSettingsKey,
    () =>
      client.query({
        name: 'moderationSettings',
        args: fields,
      }),
    useQueryOptions,
  )
}
